import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

function HawkeyeV2FilterPortal(props) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  if (isMounted) {
    return ReactDOM.createPortal(props.children, document.querySelector(".hawkeye-filter-portal"));
  } else {
    return null;
  }
}

export default HawkeyeV2FilterPortal;
